import { lazy, Suspense } from "react";
import { Navigate, useRoutes } from "react-router-dom";
import { Spin } from "antd";
import AppLayout from "@/components/AppLayout";

const Login = lazy(() => import("@/views/Login"));
const Register = lazy(() => import("@/views/Register"));
const Home = lazy(() => import("@/views/Home"));
const Resolve = lazy(() => import("@/views/Resolve"));
const Upload = lazy(() => import("@/views/Upload"));
const MySources = lazy(() => import("@/views/MySources"));
const MyDownloads = lazy(() => import("@/views/MyDownloads"));
const RedeemCode = lazy(() => import("@/views/RedeemCode"));
const Invitation = lazy(() => import("@/views/Invitation"));
const Profile = lazy(() => import("@/views/Profile"));
const Membership = lazy(() => import("@/views/Membership"));
const UserAnnouncements = lazy(
  () => import("@/views/Announcement/UserAnnouncements"),
);
const SiteAnnouncements = lazy(
  () => import("@/views/Announcement/SiteAnnouncements"),
);

const Loading = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100%",
    }}
  >
    <Spin size="large" />
  </div>
);

export default function AppRouter() {
  return useRoutes([
    {
      path: "/login",
      element: (
        <Suspense fallback={<Loading />}>
          <Login />
        </Suspense>
      ),
    },
    {
      path: "/register",
      element: (
        <Suspense fallback={<Loading />}>
          <Register />
        </Suspense>
      ),
    },
    {
      path: "/",
      element: <AppLayout />,
      children: [
        {
          index: true,
          element: (
            <Suspense fallback={<Loading />}>
              <Home />
            </Suspense>
          ),
        },
        {
          path: "resolve",
          element: (
            <Suspense fallback={<Loading />}>
              <Resolve />
            </Suspense>
          ),
        },
        {
          path: "upload",
          element: (
            <Suspense fallback={<Loading />}>
              <Upload />
            </Suspense>
          ),
        },
        {
          path: "sources",
          element: (
            <Suspense fallback={<Loading />}>
              <MySources />
            </Suspense>
          ),
        },
        {
          path: "downloads",
          element: (
            <Suspense fallback={<Loading />}>
              <MyDownloads />
            </Suspense>
          ),
        },
        {
          path: "redeem",
          element: (
            <Suspense fallback={<Loading />}>
              <RedeemCode />
            </Suspense>
          ),
        },
        {
          path: "invitation",
          element: (
            <Suspense fallback={<Loading />}>
              <Invitation />
            </Suspense>
          ),
        },
        {
          path: "profile",
          element: (
            <Suspense fallback={<Loading />}>
              <Profile />
            </Suspense>
          ),
        },
        {
          path: "membership",
          element: (
            <Suspense fallback={<Loading />}>
              <Membership />
            </Suspense>
          ),
        },
        {
          path: "announcements",
          element: (
            <Suspense fallback={<Loading />}>
              <UserAnnouncements />
            </Suspense>
          ),
        },
        {
          path: "site-announcements",
          element: (
            <Suspense fallback={<Loading />}>
              <SiteAnnouncements />
            </Suspense>
          ),
        },
      ],
    },
    { path: "*", element: <Navigate to="/" replace /> },
  ]);
}
